import {makeRequest} from './base';

export function oauth(id_token) {
  return makeRequest('/api/v4/oauth', {id_token});
}


// WEBPACK FOOTER //
// ./src/api/oauth.js